import { executePost } from "../ServiceMethods";
import { removeUserCredentials } from "../LocalStorage";
import { toast } from "react-toastify";
import { SessionTimeout } from "../ErrorMessages";

export const SwitchBusinessUser = async (data, cb) => {
  try {
    const res = await executePost("/businessuser/switch-business", data);

    const responseData = res ? res : {};
    return responseData;
  } catch (error) {
    if (error?.response?.data?.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
      });

      removeUserCredentials();
      cb && cb();
    } else {
      return false;
    }
  }
};
